import { jwtDecode } from 'jwt-decode';
import { _mock } from './_mock';

// ----------------------------------------------------------------------
const auth = JSON.parse(localStorage.getItem('token'));
let statusOptions = [];
if (auth) {
  const decoded = jwtDecode(auth);
  if (decoded?.location === 'USA') {
    statusOptions = [
      { value: 'RECEIVED IN US WAREHOUSE', label: 'RECEIVED IN US WAREHOUSE' },
      { value: 'ON HOLD', label: 'ON HOLD' },
      { value: 'NOT IDENTIFIED', label: 'NOT IDENTIFIED' },
      { value: 'DAMAGED', label: 'DAMAGED' },
      { value: 'ON THE WAY FROM US WAREHOUSE', label: 'ON THE WAY FROM US WAREHOUSE' },
      { value: 'DROPPED IN US AIRPORT FACILITY', label: 'DROPPED IN US AIRPORT FACILITY' },
      { value: 'AIR SHIPPED FROM US', label: 'AIR SHIPPED FROM US' },
      { value: 'DELAYED', label: 'DELAYED' },
    ];
  }
  if (decoded?.location === 'Georgia') {
    statusOptions = [
      // { value: 'PLACED', label: 'PLACED' },
      { value: 'AWAITING', label: 'AWAITING' },
      { value: 'RECEIVED IN US WAREHOUSE', label: 'RECEIVED IN US WAREHOUSE' },
      { value: 'ON HOLD', label: 'ON HOLD' },
      { value: 'NOT IDENTIFIED', label: 'NOT IDENTIFIED' },
      { value: 'DAMAGED', label: 'DAMAGED' },
      { value: 'ON THE WAY FROM US WAREHOUSE', label: 'ON THE WAY FROM US WAREHOUSE' },
      { value: 'DROPPED IN US AIRPORT FACILITY', label: 'DROPPED IN US AIRPORT FACILITY' },
      { value: 'AIR SHIPPED FROM US', label: 'AIR SHIPPED FROM US' },
      { value: 'DELAYED', label: 'DELAYED' },
      { value: 'CUSTOMS CLEARANCE', label: 'CUSTOMS CLEARANCE' },
      { value: 'CUSTOMS EXPERTISE', label: 'CUSTOMS EXPERTISE' },
      { value: 'RECEIVED IN TBILISI WAREHOUSE', label: 'RECEIVED IN TBILISI WAREHOUSE' },
      { value: 'OUT FOR DELIVERY', label: 'OUT FOR DELIVERY' },
      // { value: 'FAILED DELIVERY ATTEMPT', label: 'FAILED DELIVERY ATTEMPT' },
      { value: 'DELIVERED', label: 'DELIVERED' },
      { value: 'CANCELED', label: 'CANCELED' },
      {
        value: 'DEADLINE FOR THE CUSTOMS CLEARANCE COMPLETION',
        label: 'DEADLINE FOR THE CUSTOMS CLEARANCE COMPLETION',
      },
      {
        value: 'NEEDS TO BE TRANSFERRED TO GOVERNMENT',
        label: 'NEEDS TO BE TRANSFERRED TO GOVERNMENT',
      },
      { value: 'TRANSFERRED TO GOVERNMENT', label: 'TRANSFERRED TO GOVERNMENT' },
      { value: 'PICKED UP', label: 'PICKED UP' },
      { value: 'CHECKED', label: 'CHECKED' },
      { value: 'FAILED DELIVERY', label: 'FAILED DELIVERY' },
      { value: 'NOT DECLARED', label: 'NOT DECLARED' },
    ];
  }
  if (decoded?.location === 'China') {
    statusOptions = [
      // { value: 'PLACED', label: 'PLACED' },
      { value: 'AWAITING', label: 'AWAITING' },
      { value: 'RECEIVED IN US WAREHOUSE', label: 'RECEIVED IN US WAREHOUSE' },
      { value: 'ON HOLD', label: 'ON HOLD' },
      { value: 'NOT IDENTIFIED', label: 'NOT IDENTIFIED' },
      { value: 'DAMAGED', label: 'DAMAGED' },
      { value: 'ON THE WAY FROM US WAREHOUSE', label: 'ON THE WAY FROM US WAREHOUSE' },
      { value: 'DROPPED IN US AIRPORT FACILITY', label: 'DROPPED IN US AIRPORT FACILITY' },
      { value: 'AIR SHIPPED FROM US', label: 'AIR SHIPPED FROM US' },
      { value: 'DELAYED', label: 'DELAYED' },
      { value: 'CUSTOMS CLEARANCE', label: 'CUSTOMS CLEARANCE' },
      { value: 'CUSTOMS EXPERTISE', label: 'CUSTOMS EXPERTISE' },
      { value: 'RECEIVED IN TBILISI WAREHOUSE', label: 'RECEIVED IN TBILISI WAREHOUSE' },
      { value: 'OUT FOR DELIVERY', label: 'OUT FOR DELIVERY' },
      { value: 'FAILED DELIVERY ATTEMPT', label: 'FAILED DELIVERY ATTEMPT' },
      { value: 'DELIVERED', label: 'DELIVERED' },
      { value: 'CANCELED', label: 'CANCELED' },
      {
        value: 'DEADLINE FOR THE CUSTOMS CLEARANCE COMPLETION',
        label: 'DEADLINE FOR THE CUSTOMS CLEARANCE COMPLETION',
      },
      {
        value: 'NEEDS TO BE TRANSFERRED TO GOVERNMENT',
        label: 'NEEDS TO BE TRANSFERRED TO GOVERNMENT',
      },
      { value: 'TRANSFERRED TO GOVERNMENT', label: 'TRANSFERRED TO GOVERNMENT' },
      { value: 'PICKED UP', label: 'PICKED UP' },
      { value: 'CHECKED', label: 'CHECKED' },
    ];
  }
}

export const ORDER_STATUS_OPTIONS = statusOptions;

const ITEMS = [...Array(3)].map((_, index) => ({
  id: _mock.id(index),
  sku: `16H9UR${index}`,
  quantity: index + 1,
  name: _mock.productName(index),
  coverUrl: _mock.image.product(index),
  price: _mock.number.price(index),
}));

export const _orders = [...Array(20)].map((_, index) => {
  const shipping = 10;

  const discount = 10;

  const taxes = 10;

  const items = (index % 2 && ITEMS.slice(0, 1)) || (index % 3 && ITEMS.slice(1, 3)) || ITEMS;

  const totalQuantity = items.reduce((accumulator, item) => accumulator + item.quantity, 0);

  const subTotal = items.reduce((accumulator, item) => accumulator + item.price * item.quantity, 0);

  const totalAmount = subTotal - shipping - discount + taxes;

  const customer = {
    id: _mock.id(index),
    name: _mock.fullName(index),
    email: _mock.email(index),
    avatarUrl: _mock.image.avatar(index),
    ipAddress: '192.158.1.38',
  };

  const delivery = {
    shipBy: 'DHL',
    speedy: 'Standard',
    trackingNumber: 'SPX037739199373',
  };

  const history = {
    orderTime: _mock.time(1),
    paymentTime: _mock.time(2),
    deliveryTime: _mock.time(3),
    completionTime: _mock.time(4),
    timeline: [
      { title: 'Delivery successful', time: _mock.time(1) },
      { title: 'Transporting to [2]', time: _mock.time(2) },
      { title: 'Transporting to [1]', time: _mock.time(3) },
      { title: 'The shipping unit has picked up the goods', time: _mock.time(4) },
      { title: 'Order has been created', time: _mock.time(5) },
    ],
  };

  return {
    id: _mock.id(index),
    orderNumber: `#601${index}`,
    createdAt: _mock.time(index),
    taxes,
    items,
    history,
    subTotal,
    shipping,
    discount,
    customer,
    delivery,
    totalAmount,
    totalQuantity,
    shippingAddress: {
      fullAddress: '19034 Verna Unions Apt. 164 - Honolulu, RI / 87535',
      phoneNumber: '365-374-4961',
    },
    payment: {
      cardType: 'mastercard',
      cardNumber: '**** **** **** 5678',
    },
    status:
      (index % 2 && 'completed') ||
      (index % 3 && 'pending') ||
      (index % 4 && 'cancelled') ||
      'refunded',
  };
});
